import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const DAILY_FORECAST_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/daily_forecast`;
